export default "__VITE_ASSET__ffb7dfdd__"